"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withContext = void 0;
const react_1 = __importStar(require("react"));
const SelectorsHub_1 = __importDefault(require("./SelectorsHub"));
const QuestionnaireContext = react_1.default.createContext(new SelectorsHub_1.default({}));
function withContext(options) {
    return (Component) => {
        const ComponentWithContext = (props) => {
            return (react_1.default.createElement(QuestionnaireContext.Consumer, null, (context) => react_1.default.createElement(Component, Object.assign({}, props, { context: context }))));
        };
        // set display name
        const name = Component.displayName || Component.name;
        ComponentWithContext.displayName = name;
        if (options && options.forwardRef) {
            // NOTE: I cannot use <ComponentWithContext /> syntax, because
            //       ref would not be passed to <Component />; think about
            //       it as a completely different render function, though
            //       we are lucky to be able to re-use ComponentWithContext
            //       (as a function, not as a component).
            return (0, react_1.forwardRef)((props, ref) => ComponentWithContext(Object.assign(Object.assign({}, props), { ref })));
        }
        return ComponentWithContext;
    };
}
exports.withContext = withContext;
exports.default = QuestionnaireContext;
//# sourceMappingURL=QuestionnaireContext.js.map